'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dismissAgentTypingIndicator = undefined;

var _pubnubMessageGetters = require('conversations-schema/pubnub-message/operators/pubnubMessageGetters');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _clearExistingAgentTypingTimeout = require('./clearExistingAgentTypingTimeout');

var _removeTypingTimeoutIdForAgentInThread = require('./removeTypingTimeoutIdForAgentInThread');

var dismissAgentTypingIndicator = exports.dismissAgentTypingIndicator = function dismissAgentTypingIndicator(message) {
  return function (dispatch) {
    var threadId = (0, _pubnubMessageGetters.getThreadId)(message);
    var senderId = (0, _commonMessageFormatGetters.getSenderId)(message);

    dispatch((0, _clearExistingAgentTypingTimeout.clearExistingAgentTypingTimeout)(message));

    dispatch((0, _removeTypingTimeoutIdForAgentInThread.removeTypingTimeoutIdForAgentInThread)(threadId, senderId));
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/typing-indicators/actions/dismissAgentTypingIndicator.js
// module id = 224
// module chunks = 2 3